import { CALCULATION } from './_calculation';
// import { queryString } from '../../helpers';

const getBesCalculationResult = (form) => {
	return new Promise((resolve, reject) => {
		return CALCULATION.post(`/Calculation/GetBesCalculationResult`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
const getTaxCalculationResult = (form) => {
	return new Promise((resolve, reject) => {
		return CALCULATION.post(`/Calculation/GetTaxAdvantageCalculationResult`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

export { getBesCalculationResult, getTaxCalculationResult }